import i18next from "i18next";
import { Helmet } from "react-helmet";

import { seo } from "../../seo";

const ogLocaleMap = {
  uz: "uz_UZ",
  ru: "ru_RU",
  en: "en_US",
};

const SeoTags = ({ pageKey }) => {
  const { language } = i18next;

  const pageTitle = seo.titles[language][pageKey] || "";

  const pageMetaDescription = seo.metaDescriptions[language][pageKey] || "";
  const pageMetaKeywords = seo.metaKeywords[language][pageKey] || "";
  const pageMetaTitle = seo.metaTitles[language][pageKey] || "";

  const pageMetaOgObject = seo.metaOgObject[language][pageKey] || {};

  const canonicalUrl = pageMetaOgObject?.url || "";
  const ogLocale = ogLocaleMap[language] || "uz_UZ";

  return (
    <Helmet>
      {!!pageTitle && <title>{pageTitle}</title>}

      {!!pageMetaDescription && <meta name="description" content={pageMetaDescription} />}
      {!!pageMetaKeywords && <meta name="keywords" content={pageMetaKeywords} />}
      {!!pageMetaTitle && <meta name="title" content={pageMetaTitle} />}
      {!!canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:locale" content={ogLocale} />
      {!!pageMetaOgObject?.description && <meta property="og:description" content={pageMetaOgObject.description} />}
      {!!pageMetaOgObject?.image && <meta property="og:image" content={pageMetaOgObject.image} />}
      {!!pageMetaOgObject?.site_name && <meta property="og:site_name" content={pageMetaOgObject.site_name} />}
      {!!pageMetaOgObject?.title && <meta property="og:title" content={pageMetaOgObject.title} />}
      {!!pageMetaOgObject?.type && <meta property="og:type" content={pageMetaOgObject.type} />}
      {!!pageMetaOgObject?.url && <meta property="og:url" content={pageMetaOgObject.url} />}

      <meta name="twitter:card" content="summary_large_image" />
      {!!pageMetaOgObject?.title && <meta name="twitter:title" content={pageMetaOgObject.title} />}
      {!!pageMetaDescription && <meta name="twitter:description" content={pageMetaDescription} />}
      {!!pageMetaOgObject?.image && <meta name="twitter:image" content={pageMetaOgObject.image} />}
    </Helmet>
  );
};

export default SeoTags;
